var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-template-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: { "tab-remove": _vm.handleTabRemove },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        _vm._l(_vm.panes, function (pane) {
          return _c(
            "el-tab-pane",
            {
              key: pane.name,
              attrs: {
                label: pane.label,
                name: pane.name,
                closable: pane.name !== "manage",
              },
            },
            [
              pane.name === "manage"
                ? [
                    _c("menu-store-template-manage", {
                      ref: "menuStoreTemplateManage",
                      refInFor: true,
                      on: { "edit-template": _vm.handleEditTemplate },
                    }),
                  ]
                : [
                    _c("detail", {
                      ref: "templateDetail_" + pane.templateId,
                      refInFor: true,
                      attrs: { templateId: pane.templateId },
                    }),
                  ],
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }